export default "__VITE_ASSET__vPYpYC1d__"